<template>
<v-card>
<v-toolbar flat color="red" height="42">
  <v-toolbar-title style="color:white">
Удаление поста
  </v-toolbar-title>
<v-spacer/>
<v-icon @click="posts.modals.deletePost = false" color="white">mdi-close</v-icon>
</v-toolbar>

<v-card-text>
<h6 style="color:gray">Подтвердите удаление поста,  <a target="_blank" :href="'https://vk.com/'+posts.selectedPost.post_id">{{posts.selectedPost.post_id}}</a>
Отменить данную операцию будет невозможно.
</h6>
<v-checkbox color="#242F3B"  hide-details>
<span slot="label" style="margin-top:6px;font-size:.9em">По возможности удалить с vk.com</span>
</v-checkbox>
</v-card-text>
<v-card-actions>
<v-spacer/>
<v-btn @click="posts.modals.deletePost = false"   small flat color="#242F3B" style="text-transform:none"  >  Отмена</v-btn>
<v-btn @click="deletePost(posts.selectedPost.post_id)"   small color="red" style="text-transform:none" class="white--text"> <v-icon left>mdi-delete</v-icon> Удалить пост</v-btn>
</v-card-actions>


</v-card>
</template>

<script>
import axios from 'axios'
export default {
props: ['posts'],
data () {
return {
disable:true
}
},
methods: {

deletePost(postId){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/posts/delete_posts.php', {
contentType: 'JSONP',
method: 'get',
params:{
  postId:postId
}
}).then(response => {
this.$router.go()

})
},


},
computed:{
},
mounted(){
},

}
</script>

<style    >

</style>
